import { createTheme } from "@mui/material/styles";

export const amazonTheme = createTheme({
  palette: {
    primary: {
      main: "#007185", // Amazon blue
      light: "#0066cc",
      dark: "#004d99",
    },
    secondary: {
      main: "#ffd814", // Amazon yellow
      light: "#f7ca00",
      dark: "#e6b800",
    },
    success: {
      main: "#007600", // Amazon green
      light: "#00a600",
      dark: "#005a00",
    },
    warning: {
      main: "#fa8900", // Amazon orange
      light: "#ff9f1c",
      dark: "#e67e00",
    },
    error: {
      main: "#cc0c39", // Amazon red
      light: "#e31c3d",
      dark: "#a8001a",
    },
    text: {
      primary: "#0f1111", // Amazon dark text
      secondary: "#565959", // Amazon secondary text
    },
    background: {
      default: "#ffffff",
      paper: "#ffffff",
    },
    divider: "#e7e7e7", // Amazon light gray
  },
  typography: {
    fontFamily:
      '"Amazon Ember", "Helvetica Neue", Helvetica, Arial, sans-serif',
    h1: {
      fontSize: "2.5rem",
      fontWeight: 700,
      lineHeight: 1.2,
      color: "#0f1111",
    },
    h2: {
      fontSize: "2rem",
      fontWeight: 700,
      lineHeight: 1.3,
      color: "#0f1111",
    },
    h3: {
      fontSize: "1.75rem",
      fontWeight: 600,
      lineHeight: 1.3,
      color: "#0f1111",
    },
    h4: {
      fontSize: "1.5rem",
      fontWeight: 600,
      lineHeight: 1.4,
      color: "#0f1111",
    },
    h5: {
      fontSize: "1.25rem",
      fontWeight: 600,
      lineHeight: 1.4,
      color: "#0f1111",
    },
    h6: {
      fontSize: "1.125rem",
      fontWeight: 600,
      lineHeight: 1.4,
      color: "#0f1111",
    },
    body1: {
      fontSize: "1rem",
      lineHeight: 1.5,
      color: "#0f1111",
    },
    body2: {
      fontSize: "0.875rem",
      lineHeight: 1.5,
      color: "#565959",
    },
    button: {
      fontSize: "0.875rem",
      fontWeight: 600,
      textTransform: "none",
    },
  },
  spacing: 8,
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: "none",
          fontWeight: 600,
          fontSize: "0.875rem",
          padding: "12px 24px",
          minHeight: 44,
        },
        contained: {
          boxShadow: "none",
          "&:hover": {
            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
          },
        },
        containedPrimary: {
          backgroundColor: "#007185",
          "&:hover": {
            backgroundColor: "#0066cc",
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
          border: "1px solid #e7e7e7",
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          fontWeight: 500,
        },
      },
    },
  },
});

// Amazon-specific color constants
export const amazonColors = {
  yellow: "#ffd814",
  yellowHover: "#f7ca00",
  orange: "#fa8900",
  orangeHover: "#e67e00",
  blue: "#007185",
  blueHover: "#0066cc",
  green: "#007600",
  red: "#cc0c39",
  gray: {
    50: "#fafafa",
    100: "#f5f5f5",
    200: "#e7e7e7",
    300: "#d4d4d4",
    400: "#a3a3a3",
    500: "#737373",
    600: "#525252",
    700: "#404040",
    800: "#262626",
    900: "#171717",
  },
  text: {
    primary: "#0f1111",
    secondary: "#565959",
    tertiary: "#737373",
  },
};

// Amazon-specific spacing
export const amazonSpacing = {
  xs: 4,
  sm: 8,
  md: 16,
  lg: 24,
  xl: 32,
  xxl: 48,
};

// Amazon-specific shadows
export const amazonShadows = {
  sm: "0 1px 2px rgba(0,0,0,0.05)",
  md: "0 2px 8px rgba(0,0,0,0.08)",
  lg: "0 4px 12px rgba(0,0,0,0.12)",
  xl: "0 8px 24px rgba(0,0,0,0.16)",
};
